import { Repository } from "src/firebase/firestore/repository";
import { OnboardingReport, OnboardingReportStatus } from "../types/onboarding-report.entity";
import { Timestamp } from "firebase/firestore";

export class OnboardingReportRepository extends Repository<OnboardingReport> {
  constructor() {
    super("onboarding_reports"); // Make sure this matches your Firestore collection name
  }

  async find(query: any = {}) {
    const reports = await super.find(query);
    return reports;
  }

  async findByUserId(userId: string): Promise<OnboardingReport[]> {
    return this.find({
      where: { userId },
      orderBy: ["createdAt", "desc"],
    });
  }

  async findByStatus(status: string): Promise<OnboardingReport[]> {
    return this.find({
      where: { status },
      orderBy: ["createdAt", "desc"],
    });
  }

  async updateStatus(id: string, status: OnboardingReportStatus): Promise<void> {
    await this.update(id, {
      status,
      updatedAt: Timestamp.now(),
    });
  }
}

export const onboardingReportRepository = new OnboardingReportRepository();
